import clsx from 'clsx';
import { ContainerBase } from '../containers';
import { Title } from '@/components/landing/title';
import Image from 'next/image';

interface Props {
	text?: string;
	primaryColorText?: string;
	description?: string | React.ReactElement;
	customTitle?: React.ReactNode;
	classNameLineBreak?: string;
	imageUrl?: string;
	classNameImage?: string;
}

export const SimpleBanner: React.FC<Props> = ({
	text,
	primaryColorText,
	description,
	customTitle,
	classNameLineBreak,
	imageUrl,
	classNameImage,
}) => {
	return (
		<div className="mb-14 lg:mb-[88px]">
			<div
				className={`
					absolute inset-0 rounded-[64px] bg-no-repeat
					bg-[url('/img/landing/svg/bubbles-general-banner-mobile.svg')] bg-top bg-contain
					lg:bg-[url('/img/landing/svg/bubbles-general-banner.svg')] lg:bg-[position:120px_40px] lg:bg-auto`}
			/>
			<ContainerBase className="h-[153px] lg:h-[212px] pt-14 lg:pt-[100px] relative z-10">
				{customTitle || (
					<Title typographyTitle="headline-2" description={description}>
						{text} <br className={clsx('hidden', classNameLineBreak)} />
						{primaryColorText && (
							<span className="text-primary">{primaryColorText}</span>
						)}
					</Title>
				)}
				{imageUrl && (
					<Image
						src={imageUrl}
						alt="contact us image"
						width={164}
						height={140}
						className={clsx('mt-4 m-auto', classNameImage)}
					/>
				)}
			</ContainerBase>
		</div>
	);
};
